/* Größenwahl auf der Produktkarte: setzt Variante, Preis und Grundpreis (snippets/ei-produkt-karte.liquid) */
document.addEventListener('click', function (e) {
  var knopf = e.target.closest('.ei-groesse');
  if (!knopf || knopf.disabled) return;
  var karte = knopf.closest('[data-ei-karte]');
  karte.querySelectorAll('.ei-groesse').forEach(function (b) { b.setAttribute('aria-checked', b === knopf ? 'true' : 'false'); });
  karte.querySelector('input[name="id"]').value = knopf.dataset.id;
  karte.querySelector('[data-ei-preis]').textContent = knopf.dataset.preis;
  karte.querySelector('[data-ei-grundpreis]').textContent = knopf.dataset.grundpreis;
});
